import request from '@/utils/request.js'

export function loginbyuid(data) {
  return request.get('/api/H5/LoginJwt/loginbyuid', {
    params: data
  })
}

export function getuserDetail(data) {
  return request.get('/api/H5/UserCenter/getuserDetail', {
    params: data,
    noLoading: true
  })
}

export function GetJsSdkConfig(data) {
  return request.get('/api/H5/wxsdk/GetJsSdkConfig', {
    params: data
  })
}

export function getmyproductcolllist(data) {
  return request.get('/api/H5/UserCenter/getmyproductcolllist', {
    params: data
  })
}

export function edituser(data) {
  return request.post('/api/H5/UserCenter/edituser', data)
}

export function editphone(data) {
  return request.get('/api/H5/UserCenter/editphone', {
    params: data
  })
}

export function checkoldphone(data) {
  return request.get('/api/H5/UserCenter/checkoldphone', {
    params: data
  })
}

export function getcouponlist(data) {
  return request.get('/api/H5/UserCenter/getorderlist', {
    params: data
  })
}

export function getMoneyList(data) {
  return request.get('/api/H5/UserCenter/getMoneyList', {
    params: data
  })
}
